import type { CollapseTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const collapseDark: CollapseTheme = {
  name: 'Collapse',
  common: commonDark,
  self
}

export default collapseDark
